import * as React from 'react';
import { DayConfiguration, TourInterval } from '../../../../api/Property';
import FormInput from '../../../common/form/Input';
import TourIntervalConfigurationSection from './TourIntervalConfigurationSection';
import FormSelectLabeled from '../../../common/form/SelectLabeled';
import { availableTimeslots } from '../../../../utilities/timeslots';
import CollapsibleCard from '../../../common/CollapsibleCard';
import TourOfficeOpenConfigSection from './TourOfficeOpenConfigSection';

interface Props {
    dayName: string;
    dayConfiguration: DayConfiguration;
    onChange: (
        dayName: string,
        dayFieldName: string,
        newValue: string | boolean | TourInterval | number | undefined,
        secondName?: string,
        secondValue?: string
    ) => void;
    isDisabled: boolean; 
}

const DayConfigurationSection = (props: Props) => {
    const handleInputChange = (
        inputName: string,
        newValue: string | boolean | number | TourInterval | undefined,
        secondName?: string,
        secondValue?: string
    ) => {
        if (!props.isDisabled) {
        props.onChange(props.dayName.toLowerCase(), inputName, newValue, secondName, secondValue);
        }
    };

    const handleCardOpenChange = (newValue: boolean) => {
        if (!props.isDisabled) {
            handleInputChange('isTouringEnabledToday', newValue);
        }
    };

    return (
        <CollapsibleCard
            cardTitle={props.dayName}
            cardOpen={props.dayConfiguration.isTouringEnabledToday}
            onCardOpenChange={handleCardOpenChange}
        >
            <div>         
                <TourIntervalConfigurationSection
                    dayName={props.dayName}
                    intervalName="tour24 hours"
                    interval={props.dayConfiguration.tour24}
                    defaultStart={availableTimeslots[0]}
                    defaultEnd={availableTimeslots[availableTimeslots.length - 1]}
                    onChange={newValue => handleInputChange('tour24', newValue)}
                    isDisabled={props.isDisabled}
                />  
                <div className="row">
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'TIME BETWEEN TOURS',
                            invalidText: 'Please enter a downtime in minutes'
                        }}
                        selectProps={{
                            id: 'post-tour-downtime',
                            name: 'postTourDowntime',
                            value: props.dayConfiguration.postTourDowntime,
                            required: false,
                            disabled: props.isDisabled 
                        }}
                        selectOptions={[
                            { label: 'None', value: 0 },
                            { label: '15 minutes', value: 15 },
                            { label: '30 minutes', value: 30 },
                            { label: '45 minutes', value: 45 },
                            { label: '60 minutes', value: 60 }
                        ]}
                        onChange={handleInputChange}
                        className="col"
                    />
                </div>                              
                <div className="row"> 
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'Tour Length',
                            invalidText: 'Please enter a tour length in minutes'
                        }}
                        selectProps={{
                            id: 'tour-length',
                            name: 'tourLength',
                            value: props.dayConfiguration.tourLength,
                            required: props.dayConfiguration.isTouringEnabledToday,
                            disabled: props.isDisabled
                        }}
                        selectOptions={[
                            { label: '15 minutes', value: 15 },
                            { label: '30 minutes', value: 30 },
                            { label: '45 minutes', value: 45 },
                            { label: '1 hour', value: 60 },
                            { label: '1.5 hours', value: 90 },
                            { label: '2 hours', value: 120 }
                        ]}
                        onChange={handleInputChange}
                        className="col"
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Most Tours at Once',
                            invalidText: 'Please pick a maxium number of simultaneous tours'
                        }}
                        inputProps={{
                            id: 'maximum-simultaneous-tours',
                            name: 'maxTourCount',
                            value: props.dayConfiguration.maxTourCount,
                            required: props.dayConfiguration.isTouringEnabledToday,
                            type: 'number',
                            disabled: props.isDisabled
                        }}
                        onChange={handleInputChange}
                        controlCssClass="col"
                    />
                </div>
                <TourOfficeOpenConfigSection 
                     dayName={props.dayName}
                     intervalName="tour24 hours"
                     interval={props.dayConfiguration.tour24}
                     defaultStart={availableTimeslots[0]}
                     defaultEnd={availableTimeslots[availableTimeslots.length - 1]}
                     onChange={newValue => handleInputChange('tour24', newValue)}
                     isDisabled={props.isDisabled}
                />
            </div>
        </CollapsibleCard>
    );
};

export default DayConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/DayConfigurationSection.tsx